import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = ({ className = '' }) => {
  const { t } = useTranslation();

  // Usar redirección directa de navegador en lugar de React Router
  const handleNavigation = (path) => {
    window.location.href = path;
    return false;
  };

  return (
    <footer className={`footer ${className}`}>
      <div className="footer-content">
        <div className="footer-copyright">
          © floomind 2026 - {t('footer.rights')}
        </div>
        <div className="footer-links">
          <a href="/about" className="footer-link" onClick={(e)=>{e.preventDefault();handleNavigation('/about');}}>
            {t('footer.about')}
          </a>
          <a href="/terms" className="footer-link" onClick={(e)=>{e.preventDefault();handleNavigation('/terms');}}>
            {t('footer.terms')}
          </a>
          <a href="/privacy" className="footer-link" onClick={(e)=>{e.preventDefault();handleNavigation('/privacy');}}>
            {t('footer.privacy')}
          </a>
          <a href="/intellectual-property" className="footer-link" onClick={(e)=>{e.preventDefault();handleNavigation('/intellectual-property');}}>
            {t('footer.ip')}
          </a>
          <span className="footer-email"><i className="far fa-envelope"></i> hello@floomind.com</span>
        </div>
        <div className="recaptcha-legal">
          Este sitio está protegido por reCAPTCHA y aplican la 
          <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer"> Política de Privacidad</a>
          {' '}y los
          <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer"> Términos de Servicio</a> de Google.
        </div>
      </div>
    </footer>
  );
};

export default Footer; 